/* PACKAGES */
import { motion } from "framer-motion";

/* CONTAINER ANIMATION */
const containerAnimation = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 1 },
  },
};

/* DIV ANIMATION */
const animation = {
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
  hidden: {
    opacity: 0,
    y: 20,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
};

const ReturnPolicy = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-white py-6 xl:py-14 lg:py-14"
    >
      {/* CONTENT */}
      <motion.div variants={animation} className="p-0">
        <div className="container">
          <h1 className="text-4xl font-fraunces-black tracking-tight">
            Return Policy
          </h1>
          <div className="mt-10">
            <p className="text-lg font-source font-normal text-black">
              At Food Farmacy, we are committed to providing our customers with
              high-quality healthy food products and excellent customer service.
              We understand that there may be instances where you need to return
              a product, and we aim to make this process as convenient and
              straightforward as possible. Please review our return policy
              outlined below:
            </p>

            {/* POINT ONE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Eligibility for Returns
              </h5>
              <p className="text-lg font-source font-normal text-black">
                We accept returns for items that meet the following criteria:
              </p>
              <ul className="ml-8 mt-2 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  The item is unopened, unused, and in its original packaging.
                </li>
                <li className="text-lg font-source font-normal text-black">
                  The return request is initiated within 30 days of the delivery
                  date.
                </li>
                <li className="text-lg font-source font-normal text-black">
                  The item is not listed as a non-returnable or final sale
                  product (e.g., perishable goods).
                </li>
              </ul>
            </div>

            {/* POINT TWO */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Return Procedure
              </h5>
              <p className="text-lg font-source font-normal text-black">
                To initiate a return, please contact our customer support team
                via email at{" "}
                <a
                  href="mailto:support@foodfarmacy.com"
                  className="text-blue-500 font-source font-semibold"
                >
                  support@foodfarmacy.com
                </a>{" "}
                or by phone at{" "}
                <a
                  href="tel:918792795765"
                  className="text-blue-500 font-source font-semibold"
                >
                  +91 8792795765
                </a>
                . Please provide your order number and reason for cancellation.
              </p>
            </div>

            {/* POINT THREE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Return Authorization
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Once your return request is received and approved, our customer
                support team will provide you with a return authorization number
                (RMA) and instructions on how to proceed with the return.
              </p>
            </div>

            {/* POINT FOUR */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Return Shipping
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Customers are responsible for the cost of return shipping unless
                the return is due to an error on our part (e.g., incorrect item
                shipped, damaged item). We recommend using a trackable shipping
                service to ensure the safe return of the item(s).
              </p>
            </div>

            {/* POINT FIVE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Refund Process
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Upon receiving the returned item(s) and verifying their
                eligibility, we will process a refund to the original payment
                method used for the purchase. Please allow 3-5 business days for
                the refund to reflect in your account.
              </p>
            </div>

            {/* POINT SIX */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Restocking Fee
              </h5>
              <p className="text-lg font-source font-normal text-black">
                A restocking fee may be applied to certain returns, especially
                for items that are opened, used, or returned beyond the 30-day
                return window. The restocking fee will be deducted from the
                refund amount.
              </p>
            </div>

            {/* POINT SEVEN */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Non-Returnable Items
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Some items may not be eligible for return due to health and
                safety regulations or hygiene reasons. These include but are not
                limited to perishable goods, opened food items, and personalized
                products. Please check the product description for any specific
                return restrictions.
              </p>
            </div>

            {/* POINT EIGHT */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Damaged or Defective Items
              </h5>
              <p className="text-lg font-source font-normal text-black">
                If you receive a damaged or defective item, please contact us
                immediately upon receipt, and we will arrange for a replacement
                or refund at no additional cost to you.
              </p>
            </div>

            {/* POINT NINE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Exceptions
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Food Farmacy reserves the right to refuse or limit returns in
                cases of suspected fraud, abuse of the return policy, or any
                other circumstances deemed necessary by the management.
              </p>
            </div>

            <div className="mt-10">
              <p className="text-lg font-source font-normal text-black">
                By shopping with Food Farmacy, you agree to adhere to the terms
                and conditions of this return policy. We appreciate your
                understanding and cooperation in ensuring a smooth and
                satisfactory shopping experience for all our valued customers.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default ReturnPolicy;
